import { Button, Typography } from "@mui/material";
import { Link as ReactLink } from "react-router-dom";

const style = {
  button: {
    //my: 2,
    color: "black",
    display: "inline",
  },
  linkText: {
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "29px",
  },
};

const Link = (props: { url: string; text: string }) => {
  return (
    <Button component={ReactLink} to={props.url} key={props.text} size="medium" variant="text" sx={style.button}>
      <Typography variant="body1" align="center" sx={style.linkText}>
        {props.text}
      </Typography>
    </Button>
  );
};

export default Link;
